import { makeStyles } from '@material-ui/core'
import React from 'react'

import Typography from './Typography'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const PageTitle = ({ children, subtitle }) => {
  const classes = useStyles()

  return (
    <Typography variant="h2">
      <span className={classes.root}>{children}</span>
      {subtitle && (
        <Typography variant="body2" color="textSecondary">
          {subtitle}
        </Typography>
      )}
    </Typography>
  )
}

export default PageTitle
